import { render, staticRenderFns } from "./ShootingScorePK.vue?vue&type=template&id=67668768&scoped=true"
import script from "./ShootingScorePK.vue?vue&type=script&lang=js"
export * from "./ShootingScorePK.vue?vue&type=script&lang=js"
import style0 from "./ShootingScorePK.vue?vue&type=style&index=0&id=67668768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67668768",
  null
  
)

export default component.exports